module.exports = __webpack_public_path__ + "img/legacy-shape-shoe.c2a07d0f.png";